module.exports = __webpack_public_path__ + "static/media/big_hero_pts.ac06ee79.png";